import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import config from 'config';
import ReCAPTCHA from 'react-grecaptcha';

import { getCurrentLanguage } from 'modules/language/selectors/language';
import LanguageSelector from 'modules/language/components/LanguageSelector';
import { redirectTo } from 'modules/auth/actions/redirectAction';
import { Button } from 'shared/components';
import SecondaryLoginForm from './components/SecondaryLoginForm';
import PrimaryLoginForm from './components/PrimaryLoginForm';

import theme from './LoginForm.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  status: PropTypes.string.isRequired,
  captchaToken: PropTypes.string.isRequired,
  reCaptchaSiteKey: PropTypes.string,
  showReCaptcha: PropTypes.bool.isRequired,
  handleReCaptchaVerifyCallback: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
};

const defaultProps = {
  reCaptchaSiteKey: '',
};

const LoginForm = ({
  intl,
  status,
  captchaToken,
  reCaptchaSiteKey,
  showReCaptcha,
  handleReCaptchaVerifyCallback,
  handleFormSubmit,
}) => {
  const [showExtendedForm, setShowExtendedForm] = useState(false);

  return (
    <div className={ theme.root }>
      { showExtendedForm ? (
        <SecondaryLoginForm
          recaptchaRequired={ showReCaptcha && !captchaToken }
          submitFormStatus={ status }
          onSubmit={ (formData) => handleFormSubmit(formData, true) }
          hideExtendedForm={ () => setShowExtendedForm(false) }
        />
      ) : (
        <PrimaryLoginForm
          recaptchaRequired={ showReCaptcha && !captchaToken }
          submitFormStatus={ status }
          onSubmit={ (formData) => handleFormSubmit(formData, false) }
          showExtendedForm={ () => setShowExtendedForm(true) }
        />
      ) }

      <div className={ theme.footerContainer }>
        { !Number(config.org_id) &&
          <Button
            testId="login-back-button"
            onClick={ () => redirectTo('/organization-selection') }
            buttonType="naked"
            label={ intl.formatMessage({ id: 'General.Back', defaultMessage: '** Back' }) }
            iconName="arrow-left"
            iconPositionLeft
            iconPositionRtlNotReversed
            mediaResized
          />
        }
      </div>

      { !!Number(config.org_id) &&
        <div className={ theme.languagePickerContainer }>
          <LanguageSelector />
        </div>
      }

      { showReCaptcha && (
        <div className={ theme.reCaptchaContainer }>
          <ReCAPTCHA
            sitekey={ reCaptchaSiteKey }
            expiredCallback={ () => console.warn('-reCaptcha expired!!!-') }
            callback={ handleReCaptchaVerifyCallback }
            locale={ getCurrentLanguage() === 'he' ? 'iw' : 'en' }
          />
        </div>
      ) }
    </div>
  );
};

LoginForm.propTypes = propTypes;
LoginForm.defaultProps = defaultProps;

export default injectIntl(LoginForm);
